/**
 * Display options for when Action Tracker is embedded in another app (e.g. an iframe in OEE Tracker / Digital Factory),
 * passed as query params on the URL the app is opened with.
 *
 * Read once, when the bundle loads (app.component imports this file), so they keep applying after in-app navigation
 * drops the query params.
 */
const initialQueryParams = new URLSearchParams(window.location.search);

/** `?hideHeader=true`: no page header, and no item modal header on the standalone item page in an iframe. */
export const IS_HEADER_HIDDEN: boolean = initialQueryParams.get('hideHeader') === 'true';
